import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";
import { useCreateApp } from "src/services/organizations/commands/app";
import { AppType } from "src/types/apps";
import { User } from "src/types/user";
import { PATH_DASHBOARD } from "src/utils/paths";
import SnackbarUtils from "src/utils/SnackbarUtils";

import Context from "../context";

export default function useCreateAppService() {
	const { onClose } = useContext(Context);

	const { mutate, isPending } = useCreateApp();
	const queryClient = useQueryClient();
	const navigate = useNavigate();
	const { translate } = useLocales();

	const onCreateApp = (name: string, displayName: string) => {
		const user = queryClient.getQueryData<User>(["user"]);

		mutate(
			{ name, displayName, orgId: user?.organization.id ?? "" },
			{
				onSuccess: ({ id }) => {
					SnackbarUtils.success(translate("new_app.new_app_success"));
					queryClient.setQueryData(["apps"], (oldData: AppType[]) => [
						...oldData,
						{ name, displayName, id }
					]);

					onClose();

					queryClient.setQueryData(["apps", "selected"], id);
					navigate({ to: PATH_DASHBOARD.app.overview });
				},
				onError: () => {
					SnackbarUtils.error(translate("new_app.new_app_error"));
				}
			}
		);
	};

	return { onCreateApp, isPending };
}
